module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-bar"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.newobject",
      modifiers: {
        "newobject": true
      }
    }],
    staticClass: "new-btn mr-4",
    attrs: {
      "variant": "warning"
    }
  }, [_vm._v("\n\t\t\tNeu\n\t\t")]), _vm._v(" "), (_vm.activeObjectsSelected) ? _c('erco-dropdown', {
    staticClass: "mr-1",
    attrs: {
      "label": "Aktion",
      "items": _vm.actions,
      "useLabelInline": true
    },
    on: {
      "change": _vm.handleActionClick
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeObjectsSelected) ? _c('erco-dropdown', {
    staticClass: "mr-1",
    attrs: {
      "label": "Status ändern",
      "items": _vm.statiList,
      "useLabelInline": true
    },
    on: {
      "change": _vm.handleStatiClick
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeObjectsSelected) ? _c('b-btn', {
    staticClass: "selection-reset ml-4",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleObjectSelectionReset
    }
  }, [_vm._v("\n\t\t\tAuswahl aufheben\n\t\t")]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    staticClass: "new-object-modal",
    attrs: {
      "id": "newobject",
      "title": "Neues Objekt anlegen",
      "closeTitle": "Schließen"
    },
    on: {
      "ok": _vm.handleNewClick,
      "shown": _vm.clearNewObjectDataset
    }
  }, [_c('b-alert', {
    staticClass: "alert-list",
    attrs: {
      "variant": "warning",
      "show": _vm.alertTextList.length > 0
    }
  }, _vm._l((_vm.alertTextList), function(alertText, index) {
    return _c('p', {
      key: index,
      staticClass: "_item"
    }, [_vm._v("\n\t\t\t\t\t• " + _vm._s(alertText) + "\n\t\t\t\t")])
  })), _vm._v(" "), _c('erco-text-input', {
    ref: "modalObjectnameInput",
    attrs: {
      "label": "Objektname"
    },
    on: {
      "change": _vm.handleObjectnameChange
    }
  }), _vm._v(" "), _c('erco-dropdown', {
    ref: "modalObjectSpecificationDropdown",
    staticClass: "mr-1 d-block specification-dropdown",
    attrs: {
      "label": "Spezifikation",
      "items": _vm.userSpecificationsDropdown
    },
    on: {
      "change": _vm.handleSpecificationClick
    }
  }), _vm._v(" "), _c('erco-dropdown', {
    ref: "modalObjectGenusDropdown",
    staticClass: "mr-1 d-block genus-dropdown",
    attrs: {
      "label": "Gattung",
      "items": _vm.selectedUserSpecificationGenusDropdown
    },
    on: {
      "change": _vm.handleGenusClick
    }
  })], 1), _vm._v(" "), _c('b-modal', {
    ref: "actionConfirmation",
    staticClass: "action-confirmation-modal",
    attrs: {
      "id": "action-confirmation",
      "title": "Statusänderung",
      "closeTitle": "Abbrechen"
    },
    on: {
      "ok": _vm.handleStatiModalClick,
      "shown": _vm.resetSelectedActionStatus
    }
  }, [_c('p', {
    staticClass: "_infotext"
  }, [(_vm.activeObjectSelection.length === 1) ? _c('span', [_vm._v("Den Status des folgenden Objekts")]) : _c('span', [_vm._v("Den Status der folgenden Objekte")]), _vm._v("\n\t\t\t\twirklich auf "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.selectedActionStatus.currentText))]), _vm._v(" setzen?\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "selected-obj-list-container"
  }, [(_vm.activeObjectSelection.length > 0) ? _c('b-list-group', {
    staticClass: "selected-obj-list"
  }, _vm._l((_vm.activeObjectSelection), function(selectedObj) {
    return _c('b-list-group-item', {
      key: selectedObj.PKM_Objekt,
      staticClass: "_entry_"
    }, [_c('span', {
      staticClass: "_image",
      style: (("background-image: url(" + (_vm.getImageSrcForObject(selectedObj)) + ");"))
    }), _vm._v(" "), _c('span', {
      staticClass: "_title font-weight-bold"
    }, [_vm._v(_vm._s(selectedObj.S_de_Objekt))]), _vm._v(" "), _c('span', {
      staticClass: "_id float-left text-muted"
    }, [_vm._v(_vm._s(selectedObj.PKM_Objekt))]), _vm._v(" "), _c('span', {
      staticClass: "_badge"
    }, [_c('erco-status-badge', {
      attrs: {
        "status": selectedObj.S_Status
      }
    })], 1)])
  })) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4b59da2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/ErcoEditbar.vue
// module id = 670
// module chunks = 0